module.exports = __webpack_public_path__ + "e61ffdb56537a6c8fac4b10b23d1d084.png";